module.exports = __webpack_public_path__ + "img/9.150f4a62.svg";